import SignupPage from './signup';

export default SignupPage